const VERIFICATION_PENDING = {
  screenDataAid: "awaitingConfirmation",
  iconDataAid: "top",
  headerData: {
    dataAid: "orderCancelRequest",
  },
  title: {
    text: "Payment confirmation pending",
    dataAid: "title",
  },
  subtitle: {
    text: "It may take up to 10 minutes to get the payment confirmation. If we don't get the confirmation by then, we'll process a refund",
    dataAid: "subtitle",
  },
  cta: {
    text: "Okay",
    dataAid: "primary",
  },
  transactionsHistoryCta: {
    text: 'View transaction history',
    dataAid: 'transactionHistory',
  }
};

const CANCELLED = {
  screenDataAid: "orderCancelled",
  iconDataAid: "top",
  headerData: {
    dataAid: "orderCancelRequest",
  },
  title: {
    text: "Payment cancelled",
    dataAid: "title",
  },
  subtitle: {
    text: "If any amount is debited from your account, it will be credited back within 3-5 working days",
    dataAid: "subtitle",
  },
  cta: {
    text: "Okay",
    dataAid: "primary",
  },
  transactionsHistoryCta: {
    text: 'View transaction history',
    dataAid: 'transactionHistory',
  }
};

const FAILED = {
  screenDataAid: "orderFailed",
  iconDataAid: "top",
  headerData: {
    dataAid: "orderFailedRequest",
  },
  title: {
    text: "Payment failed",
    dataAid: "title",
  },
  subtitle: {
    text: "If any amount is debited from your account, it will be credited back within 3-5 working days",
    dataAid: "subtitle",
  },
  cta: {
    text: "Retry",
    dataAid: "primary",
  },
};

const EQUITY_FUNDS_ADDED = {
  title: {
    text: 'Payment successful',
    dataAid: 'title',
  },
  subtitle: {
    text: 'Funds added will be available for trading shortly',
    dataAid: 'subtitle',
  },
  cta: {
    text: "Okay",
    dataAid: "primary",
  },
  transactionsHistoryCta: {
    text: 'View transaction history',
    dataAid: 'transactionHistory',
  }
}

const MF_SUCCESS_CTA = {
   yourOrders: {
     title: 'TRACK orders'
   },
   automateSip: {
     title: 'Setup easysip',
   }
}

const PAYMENT_STATUS = {
  CANCELLED,
  VERIFICATION_PENDING,
  EQUITY_FUNDS_ADDED,
  FAILED,
  MF_SUCCESS_CTA,
};

export default PAYMENT_STATUS;
